<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Multiselect from 'vue-multiselect'
import { Helper, debounce } from '@/mixin/helper'
import SyncVehicleLog from './Tracking/SyncVehicleLog.vue'
import ExportVehicleLog from './Tracking/ExportVehicleLog.vue'
import SyncIccidLog from './Tracking/SyncIccidLog.vue'
import SyncMoveVehicleCompanyLog from './Tracking/SyncMoveVehicleCompanyLog.vue'
import $store from '@/state/store'
import { required, requiredIf, minLength } from 'vuelidate/lib/validators'
import {
  DEVICE_MUTATION_DELETE,
  DEVICE_MUTATION_UPDATE,
  GET_DEVICE_CODE,
} from '@/services/api/master/tracking'
import { GET_COMPANYS } from '@/services/api/master/companies'
import { mapGetters } from 'vuex'
import { getToolsClient } from '@/services/tools'
import { getVSMSRestClient } from '@/services/vsms'
import { getSmsClient } from '@/services/sms'
import * as deviceApi from '@/services/rest-api-sms/lib/device/device'
import * as syncDevices from '@/services/rest-api-sms/lib/erp/sync-device'
import * as vehicleApi from '@/services/rest-api-sms/lib/vehicle/vehicle'
import * as toolsVehicleApi from '@/services/rest-api-tools/lib/vehicle/vehicle'
import McRadioButton from '@/components/McRadioButton'
import * as companyApi from '@/services/rest-api-sms/lib/company/company'
import * as vgroupsApi from '@/services/rest-api-sms/lib/vgroups/vgroups'
import McButton from '@/components/McButton'

const toolsAxios = getToolsClient()
const vsmsAxios = getVSMSRestClient()
const smsAxios = getSmsClient()

/**
 * Starter component
 */
export default {
  page: {
    title: 'Data Tracking',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  apollo: {
    companies: {
      query: GET_COMPANYS,
    },
    deviceTypes: {
      query: GET_DEVICE_CODE,
    },
  },

  components: {
    Layout,
    PageHeader,
    Multiselect,
    SyncVehicleLog,
    ExportVehicleLog,
    SyncIccidLog,
    McRadioButton,
    McButton,
    SyncMoveVehicleCompanyLog,
  },

  mixins: [Helper],

  props: {
    componentId: {
      type: String,
      default: 'device-setup', // default agar tidak error jika tidak dipassing
    },
  },

  async created() {
    await this.getDevices()
    this.$v.set.$touch()
  },

  mounted() {
    this.$set(this.set, 'actionType', null)
    this.observer = new IntersectionObserver(this.infiniteScroll)
    this.getVehicleStatuses()
  },

  data() {
    return {
      filterApi: {
        vendorCode: null,
        deviceCode: null,
        status: null,
        orderBy: [JSON.stringify({ imei: 'asc' })],
      },
      selected: {
        tracking: [],
        listHistory: [],
      },
      selectedModel: {
        tracking: [],
        listHistory: [],
      },
      allSelected: {
        tracking: false,
        listHistory: false,
      },
      indeterminate: {
        tracking: true,
        listHistory: true,
      },
      endPoint: '',
      optionMessage: null,
      message: '',
      filterMonth: '',
      license_plat: null,
      lokasi: null,
      fav: null,
      select: '',
      vendor: null,
      tipePerangkat: null,
      filterHistory: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterRiwayat: null,
      filterOn: [],
      sortBy: 'imei',
      sortDesc: false,
      loading: false,
      isLoading: false,
      vehicle: null,
      phoneNo: null,
      form: {
        identifier: null,
        licensePlate: null,
        deviceCode: null,
        vendorCode: null,
        portKernel: 8099,
        companyId: 1,
        imei: null,
        phoneNo: null,
        status: 0,
      },
      formOld: {
        identifier: null,
        deviceCode: null,
        vendorCode: null,
        portKernel: 8099,
        companyId: 1,
        imei: null,
        phoneNo: null,
        status: 0,
      },
      show_model: null,
      show: [
        { key: 'imei', label: 'Imei' },
        { key: 'identifier', label: 'ID Pelacak' },
        { key: 'vendor_type', label: 'Vendor' },
        { key: 'device_name', label: 'Tipe Perangkat' },
        { key: 'phone_number', label: 'No Telepon' },
        { key: 'status', label: 'Status' },
      ],
      isAddFavorit: false,
      addFavorit: null,
      showModal: false,
      isChanging: false,
      isChangingSimCard: false,
      isChangingDevice: false,
      isMirroring: false,
      isMovingUnit: false,
      massage: '',
      set: {
        imei: '',
        newImei: null,
        companies: null,
        phoneNo: '',
        vendorType: '',
        deviceName: '',
        vehicleId: null,
        licensePlate: null,
        companyId: null,
        odo: null,
        selectedVehicle: null,
        actionType: null,
        selectedVehicleType: null,
        vehicleYear: null,
        hullNo: null,
        odometer: null,
        domainName: null,
        workOrderNumber: '',
        notes: '',
        vehicleDataId: null,
        selectedVgroup: null,
        iccid: null,
        isIccidValid: false,
      },
      origin: {
        imei: '',
        newImei: null,
        companies: null,
        phoneNo: '',
        vendorType: '',
        deviceName: '',
        vehicleId: null,
        licensePlate: null,
        companyId: null,
        odo: null,
        selectedVehicle: null,
        actionType: null,
        selectedVehicleType: null,
        vehicleYear: null,
        hullNo: null,
        odometer: null,
        domainName: null,
        workOrderNumber: '',
        notes: '',
        vehicleDataId: null,
        selectedVgroup: null,
        iccid: null,
        isIccidValid: false,
      },
      companies: {
        companies: [],
      },
      optionProcess: null,
      needValidationProcess: ['Unregister', 'Pindah Unit', 'Ganti simcard', 'Ganti perangkat'],
      observer: null,
      size: 10,
      search: null,
      initialDeviceData: {},
      imei: null,
      syncVehicleLogModal: false,
      exportVehicleLogModal: false,
      syncIccidLogModal: false,
      syncMoveVehicleCompanyLogModal: false,
      vendorCode: [
        {
          labelName: 'McEasy',
        },
        {
          key: 1,
          labelName: 'EasyGo',
        },
        {
          key: 2,
          labelName: 'Foxlogger',
        },
        {
          key: 3,
          labelName: 'SuperSpring',
        },
        {
          key: 100,
          labelName: 'Other',
        },
      ],
      deviceCode: [
        {
          key: 1001,
          labelName: 'Concox GT06N',
        },
        {
          key: 1002,
          labelName: 'Concox X3',
        },
        {
          key: 1003,
          labelName: 'Concox JC400 (Dashboard Camera)',
        },
      ],
      devices: [],
      formStatus: 'create',
      status: '',
      listDeleted: [],
      filteredItems: [],
      vehicleTypes: [],
      selectedDomainName: null,
      selectedServerRegion: 'SG',
      radioOptions: [
        { value: 'detach', label: 'master.tracking.detach' },
        { value: 'attach', label: 'master.tracking.attach' },
        { value: 'detach_attach', label: 'master.tracking.detachAttach' },
      ],
      vehicleOptions: [],
      vehicleTypeOptions: [],
      vgroupOptions: [],
      customVehicleError: null,
      formVehicleId: null,
      setVehicleId: {},
      formNewImei: null,
      setNewImei: {},
      transferMode: 'device_only',
      companyOptions: [],
      formCache: {
        device_only: {},
        device_vehicle: {},
      },
    }
  },

  validations: {
    form: {
      identifier: { required },
      deviceCode: { required },
      vendorCode: { required },
      imei: { required },
      phoneNo: { required },
      status: { required },
    },
    set: {
      companies: { required },
      identifier: { required },
      newImei: { required },
      phoneNo: { required },
      odo: { required },
      selectedVehicle: { required },
      selectedVehicleType: { required },
      selectedVgroup: { required },
      odometer: { required },
      workOrderNumber: {
        required: requiredIf(function () {
          return this.isProcessMetadataRequired
        }),
      },
      notes: {
        required: requiredIf(function () {
          return this.isProcessMetadataRequired
        }),
        minLength(value) {
          return !this.isProcessMetadataRequired || minLength(10)(value)
        },
      },
    },
  },

  computed: {
    title() {
      return this.$t('master.tracker')
    },

    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        var result = this.show_model.map((a) => a.key)

        return this.tracking.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.tracking
      }
    },

    tracking() {
      const columns = [
        {
          key: 'assigned_on',
          label: this.$t('device.assignAt'),
          sortable: true,
        },
        {
          key: 'company_name',
          label: this.$t('task.column.company'),
          sortable: true,
        },
        {
          key: 'domain_name',
          label: this.$t('domain.table.domainName'),
          sortable: true,
        },
        {
          key: 'license_plate',
          label: this.$t('master.form.fleet.licensePlate'),
          sortable: true,
        },
        {
          key: 'vehicle_type_name',
          label: this.$t('vehicle.vehicleType'),
          sortable: true,
        },
        {
          key: 'hull_no',
          label: this.$t('vehicle.hullNo'),
          sortable: true,
        },
        {
          key: 'imei',
          label: this.$t('master.list.tracker.imei'),
          sortable: true,
        },
        {
          key: 'phone_no',
          label: this.$t('master.list.tracker.phoneNo'),
          sortable: true,
          tdClass: 'text-nowrap',
          thClass: 'text-nowrap',
        },
        {
          key: 'iccid',
          label: 'Iccid',
          sortable: true,
        },
        {
          key: 'device_name',
          label: this.$t('task.column.deviceType'),
          sortable: true,
        },
        {
          key: 'last_receive',
          label: this.$t('vehicle.status.lastReceive'),
          sortable: true,
        },
        {
          key: 'signal_status',
          label: this.$t('vehicle.status.signal'),
          sortable: true,
        },
        // Dont Delete
        // {
        //   key: 'live_view_status',
        //   label: this.$t('vehicle.status.liveView'),
        //   sortable: true,
        // },
        {
          key: 'latitude',
          label: this.$t('vehicle.status.latitude'),
          sortable: true,
        },
        {
          key: 'longitude',
          label: this.$t('vehicle.status.longitude'),
          sortable: true,
        },
        {
          key: 'device_status',
          label: this.$t('master.list.tracker.status'),
          sortable: true,
        },
        {
          key: 'engine_on',
          label: this.$t('vehicle.status.ignition'),
          sortable: true,
        },
        {
          key: 'speed',
          label: this.$t('vehicle.status.speed'),
          sortable: true,
        },
        {
          key: 'battery',
          label: this.$t('vehicle.status.battery'),
          sortable: true,
        },
        {
          key: 'motion_status',
          label: this.$t('vehicle.status.motionStatus'),
          sortable: true,
        },
        {
          key: 'door_sensor',
          label: this.$t('sensor.doorSensor'),
          sortable: true,
        },
        {
          key: 'fuel_sensor',
          label: this.$t('sensor.fuelSensor'),
          sortable: true,
        },
        {
          key: 'temperature_sensor',
          label: this.$t('sensor.temperatureSensor'),
          sortable: true,
        },
        {
          key: 'is_support_adas',
          label: this.$t('device.type.adas'),
          sortable: true,
        },
        {
          key: 'is_support_dms',
          label: this.$t('device.type.dms'),
          sortable: true,
        },
        {
          key: 'is_multi_imei',
          label: this.$t('device.multiImei'),
          sortable: true,
        },
        {
          key: 'vendor_type',
          label: this.$t('master.list.tracker.provider'),
          sortable: true,
        },
        {
          key: 'syncIccid',
          label: 'Sync Iccid',
        },
        {
          key: 'view',
          label: 'View',
        },
      ]

      // Only add the sync_device column if user has access
      if (this.hasAccessAll(['sync_vehicle_log:create']) && this.flagSyncErp) {
        columns.splice(columns.length - 1, 0, {
          key: 'sync_device',
          label: 'Sync Device',
        })
      }

      return columns
    },

    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
      getFeatureFlagData: 'identity/getFeatureFlagData',
    }),

    flagSyncErp() {
      return $store.state.config.syncToERP
    },

    processOptions() {
      const base = ['Unregister', 'Ganti perangkat', 'Ganti simcard']

      if (this.hasAccessAll(['sms-move-vehicle-company-log:create'])) {
        base.push('Pindahkan ke Company lain')
      }

      if (this.hasAccessAll(['sms-device-mirroring:create'])) {
        base.push('Mirroring')
      }

      if (this.hasAccessAll(['sms-device-move:update'])) {
        base.push('Pindah Unit')
      }

      return base
    },

    isDeviceStatusProcessActive() {
      return this.getFeatureFlagData('device_status_process').value
    },

    isProcessMetadataRequired() {
      return this.isDeviceStatusProcessActive && this.needValidationProcess.includes(this.optionProcess)
    },
  },

  watch: {
    selectedDomainName: {
      handler() {
        this.getDevices()
      },
      immediate: false,
    },
    'set.companies'(newVal, oldVal) {
      if (newVal !== oldVal) {
        // reset vehicle
        this.formVehicleId = null
      }
    },
  },

  methods: {
    // 1️⃣ UPDATE selectProcess() - JANGAN reset semua field
    async selectProcess(item) {
      // ✅ PERBAIKAN: Hanya reset flags proses, bukan semua data
      this.isChanging = item === 'Pindahkan ke Company lain'
      this.isChangingDevice = item === 'Ganti perangkat'
      this.isChangingSimCard = item === 'Ganti simcard'
      this.isMirroring = item === 'Mirroring'
      this.isMovingUnit = item === 'Pindah Unit'

      // Reset hanya field universal (WO & notes), PRESERVE data input user
      this.set.workOrderNumber = ''
      this.set.notes = ''
      // this.transferMode = 'device_only'

      // // reset cache juga biar clean
      // this.formCache = {
      //   device_only: {},
      //   device_vehicle: {}
      // }

      if (this.$v?.set) {
        this.$v.set.$reset()
      }

      await this.$nextTick()

      // Handle specific logic per process (jika ada)
      if (item === 'Pindahkan ke Company lain') {
        let params = { limit: 1, page: 1 }
        let response = await companyApi.get(params, this.selectedServerRegion)
        if (response.status && response.metadata.total_count > 1) {
          params.limit = response.metadata.total_count
          response = await companyApi.get(params, this.selectedServerRegion)
          if (response.status) {
            this.companyOptions = response.data.paginated_result
          }
        }
      }
    },

    getProcessDescription(process) {
      const descriptions = {
        Unregister:
          'Lepas perangkat dari kendaraan. Perangkat kembali ke McEasy, kendaraan tetap di customer.',
        'Pindahkan ke Company lain':
          'Memindahkan perangkat ke domain lain. Data lama tersimpan, perangkat aktif di domain baru.',
        'Ganti perangkat': 'Ganti perangkat lama dengan perangkat baru dalam kendaraan yang sama.',
        'Ganti simcard': 'Ganti SIM card lama dengan yang baru di kendaraan & domain yang sama.',
        Mirroring: 'Duplikasi kendaraan ke domain lain untuk pemantauan bersama.',
        'Pindah Unit': 'Pindahkan perangkat ke kendaraan lain dalam company yang sama.',
      }
      return descriptions[process] || ''
    },

    viewConfig(item) {
      item.serverRegion = this.selectedServerRegion
      localStorage.setItem('device', JSON.stringify(item))
      this.$router.push({
        name: 'Setting Device',
      })
    },

    async getVehicles(params) {
      if (!this.set.companies) {
        this.$toast.error('Pilih target company terlebih dahulu!')
        return
      }

      if (params) {
        params.filters = [`company_id eq ${this.set.companies.id}`, `imei is null`]
        params.limit = 1
      }

      let response = await toolsVehicleApi.getVehicleUnregistered(params)
      const totalCount = response.metadata.total_count

      params.limit = totalCount
      response = await toolsVehicleApi.getVehicleUnregistered(params)

      return response
    },

    async getVehicleStatuses(_params) {
      let params = {
        page: 1,
        limit: this.limit,
      }

      if (_params) {
        params = {
          page: _params.page,
          limit: _params.limit,
          search: _params.search,
        }
      }
      const vehicleStatuses = await vsmsAxios.get('/vehicle-status', { params }).catch((error) => {
        this.handleError(error)
      })

      if (!vehicleStatuses?.data) return
      return vehicleStatuses.data
    },

    async getVehiclesFromVehicleStatus(_params) {
      const vehicleStatuses = await this.getVehicleStatuses(_params)

      vehicleStatuses.data.paginated_result.map((item) => {
        item.imei = item.vehicle.imei
        return item
      })

      return vehicleStatuses
    },

    fetchOptions: debounce(function (search) {
      this.search = search
      this.getVehiclesFromVehicleStatus()
    }, 600),

    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        this.size += 10
        await this.$nextTick()
        this.getVehiclesFromVehicleStatus()
        ul.scrollTop = scrollTop
      }
    },

    onClose() {
      this.observer.disconnect()
    },

    getSignalType(device) {
      let data = {
        bg: 'bg-light',
        text: 'Disconnect',
        icon: 'disconnect',
        color: 'text-dark',
      }
      const lastReceive = new Date(device.item.last_receive)
      const now = new Date()
      const diffMinutes = (now.getTime() - lastReceive.getTime()) / 1000 / 60

      if (isNaN(lastReceive.getTime()) || diffMinutes > device.item.offline_timeout) {
        return data
      }

      const signal = device.item.signal_strength
      if (signal > 2)
        data = {
          bg: 'badge-soft-success',
          text: 'High',
          icon: 'high',
          color: 'text-success',
        }
      if (signal === 2)
        data = {
          bg: 'badge-soft-warning',
          text: 'Medium',
          icon: 'med',
          color: 'text-warning',
        }
      if (signal === 1)
        data = {
          bg: 'badge-soft-danger',
          text: 'Low',
          icon: 'low',
          color: 'text-danger',
        }

      return data
    },

    getLiveViewStatus(status) {
      let data = {
        bg: 'bg-secondary',
        text: 'Offline',
      }
      switch (status) {
        case 'M':
          data = {
            bg: 'bg-success',
            text: 'Moving',
          }
          break
        case 'I':
          data = {
            bg: 'bg-warning',
            text: 'Idle',
          }
          break
        case 'P':
          data = {
            bg: 'bg-danger',
            text: 'Parking',
          }
          break
        case 'A':
          data = {
            bg: 'bg-primary',
            text: 'Assisted',
          }
          break
        case 'U':
          data = {
            bg: 'bg-secondary',
            text: 'Offline',
          }
          break
      }
      return data
    },

    async getVehicleTypes(params) {
      const vehicleTypes = await vsmsAxios.get('/vehicle/type/' + this.set.vehicleId, {
        params: params,
      })
      this.vehicleTypes = vehicleTypes?.data.data.paginated_result
      return vehicleTypes.data
    },

    customLabel(item) {
      return `${item.name} (${item.domainName})`
    },

    handleError(error) {
      if (error.response) {
        const errorStatus = error.response.status
        const errorData = error.response.data

        if (errorStatus === 400 && errorData.details) {
          errorData.details.forEach((element) => {
            this.$toast.error(`${errorData.error}: ${element.field} ${element.message}`)
          })
        } else if (errorStatus === 401) {
          this.$toast.error(errorData.error)
          localStorage.removeItem('token')
          localStorage.removeItem('tokenAccess')
          this.$router.push({ name: 'Login' })
        } else if (errorStatus === 403) {
          this.$toast.error(errorData.error)
        } else if (errorStatus === 409) {
          if (errorData.details) {
            errorData.details.forEach((element) => {
              this.$toast.error(`${element.message}`)
            })
          } else {
            this.$toast.error(errorData.message)
          }
        } else {
          this.$toast.error(errorData.error)
        }
      } else if (error.request) {
        this.$toast.error(error.response.statusText)
      } else {
        this.$toast.error(error.message)
      }
    },

    selectCompany(e) {
      if (e) {
        this.select = e.name
        this.companyId = e.id
        this.getVehicles()
      }
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    async saveProcess() {
      this.isLoading = true
      let input = null
      let config = {}

      // 🧩 Mapping proses -> field validasi
      const processMetadataFields = this.isProcessMetadataRequired
        ? ['workOrderNumber', 'notes']
        : []

      const processValidationMap = {
        isMovingUnit: [
          'selectedVehicle',
          'selectedVehicleType',
          'odometer',
          'selectedVgroup',
          ...processMetadataFields,
        ],
        isChanging: [
          'companies',
          'phoneNo',
          'odo',
          'selectedVehicleType',
          ...processMetadataFields,
        ],
        isMirroring: ['companies', ...processMetadataFields],
        isChangingSimCard: ['phoneNo', ...processMetadataFields],
        isChangingDevice: ['newImei', ...processMetadataFields],
        unregister: [...processMetadataFields],
      }

      // 🧭 Tentukan proses saat ini
      let currentProcessKey = Object.keys(processValidationMap).find((key) => this[key])

      // Handle unregister process
      if (this.optionProcess === 'Unregister') {
        currentProcessKey = 'unregister'
      }

      // ⚙️ Validasi (kecuali jika kondisi tertentu dilewati)
      if (this.$v?.set && currentProcessKey) {
        const shouldSkipMoveUnitVehicleValidation =
          currentProcessKey === 'isMovingUnit' && this.set.actionType === 'detach'

        let fieldsToValidate = [...processValidationMap[currentProcessKey]]

        if (shouldSkipMoveUnitVehicleValidation) {
          fieldsToValidate = fieldsToValidate.filter((field) =>
            processMetadataFields.includes(field)
          )
        }

        if (currentProcessKey === 'isChanging' && this.transferMode === 'device_vehicle') {
          fieldsToValidate = fieldsToValidate.filter(
            (field) => !['phoneNo', 'odo', 'selectedVehicleType'].includes(field)
          )
        }

        fieldsToValidate.forEach((key) => this.$v.set[key]?.$touch())

        const invalidFields = fieldsToValidate.filter((key) => this.$v.set[key]?.$error)

        if (invalidFields.length || this.customVehicleError) {
          this.isLoading = false
          return
        }
      }

      // 🚀 Proses utama berdasarkan optionProcess
      if (this.optionProcess === 'Unregister') {
        const data = {
          wo: this.set.workOrderNumber,
          reason: this.set.notes,
        }
        const response = await vehicleApi.unassignDevice(
          data,
          this.set.vehicleId,
          this.selectedServerRegion
        )
        if (response.status !== 204 && response.status !== 200) {
          this.isLoading = false
          this.$mcToast.error(response.data?.message || this.$t('master.tracking.unassign.failed'))
        } else {
          this.$mcToast.success(this.$t('master.tracking.unassign.success'))
        }
        this.isLoading = false
        this.getDevices()
        this.$bvModal.hide('device-setup')
        this.resetModal()
        return
      }

      if (this.optionProcess === 'Ganti simcard') {
        const payload = {
          phone_no: this.set.phoneNo,
          wo: this.set.workOrderNumber,
          reason: this.set.notes,
        }
        const response = await deviceApi.update(payload, this.set.imei, this.selectedServerRegion)
        if (response.status !== 200) {
          console.log(response)
        } else {
          this.$mcToast.success(response.data?.message || this.$t('master.tracking.update.success'))
        }
        this.isLoading = false
        this.getDevices()
        this.$bvModal.hide('device-setup')
        this.resetModal()
        return
      }

      if (this.optionProcess === 'Ganti perangkat') {
        const payload = {
          imei: this.set.newImei,
          wo: this.set.workOrderNumber,
          reason: this.set.notes,
        }
        const response = await vehicleApi.changeDevice(
          payload,
          this.set.vehicleId,
          this.selectedServerRegion
        )
        if (response.status !== 200) {
          console.log(response)
        } else {
          this.$mcToast.success(this.$t('master.tracking.change.success'))
        }
        this.isLoading = false
        this.getDevices()
        this.$bvModal.hide('device-setup')
        this.resetModal()
        return
      }

      if (this.optionProcess === 'Pindahkan ke Company lain') {
        input = {
          company_id: this.set.companies.id,
          transfer_mode: this.transferMode,
          wo: this.set.workOrderNumber,
          reason: this.set.notes,
        }
        if (this.transferMode === 'device_only') {
          input.vehicle_id = this.set.selectedVehicle.vehicle_id
          input.license_plate = this.set.selectedVehicle.license_plate
          input.phone_no = this.set.phoneNo
          input.odometer = parseInt(this.set.odo) * 1000
          input.vehicle_type_id = this.set.selectedVehicleType?.vehicle_type_id
          if (this.set.vehicleYear) input.year = parseInt(this.set.vehicleYear)
          if (this.set.hullNo?.trim()) input.hull_no = this.set.hullNo
        }
        const response = await deviceApi.update(input, this.set.imei, this.selectedServerRegion)
        if (response.status) {
          if (this.transferMode === 'device_vehicle') {
            this.$toast.success(this.$t('Device dalam proses pemindahan ke company lain'))
          } else {
            this.$toast.success(this.$t('Device berhasil dipindahkan ke company lain'))
          }
        } else {
          console.log(response)
        }
        this.isLoading = false
        this.getDevices()
        this.$bvModal.hide('device-setup')
        this.resetModal()
        return
      }

      if (this.optionProcess === 'Mirroring') {
        const payload = {
          target_company_id: this.set.companies.id,
          imei: this.set.imei,
          wo: this.set.workOrderNumber,
          reason: this.set.notes,
        }
        const response = await deviceApi.mirroring(payload, this.selectedServerRegion)
        if (response.status) {
          this.$toast.success(this.$t('device.request.mirroring.success'))
        } else {
          console.log(response)
          this.$toast.error(response.message)
        }
        this.isLoading = false
        this.getDevices()
        this.$bvModal.hide('device-setup')
        this.resetModal()
        return
      }

      if (this.optionProcess === 'Pindah Unit') {
        try {
          const vgroupIds = this.set.selectedVgroup.map((v) => v.vgroup_id)
          const payload = {
            vehicle_type_id: this.set.selectedVehicleType?.vehicle_type_id,
            imei: this.set.imei,
            license_plate: this.set.selectedVehicle?.license_plate,
            odometer: parseInt(this.set.odometer || 0) * 1000,
            company_id: this.set.companyId,
            vgroup_ids: vgroupIds,
            wo: this.set.workOrderNumber,
            reason: this.set.notes,
          }

          if (this.set.vehicleYear) payload.year = parseInt(this.set.vehicleYear)
          if (this.set.hullNo?.trim()) payload.hull_no = this.set.hullNo

          const region = this.selectedServerRegion
          const action = this.set.actionType
          const selectedVehicleId = this.set.selectedVehicle?.vehicle_id
          const oldVehicleId = this.set.vehicleDataId

          const handleUpdateOrCreate = async (payload, vehicleId) =>
            vehicleId
              ? await vehicleApi.update(vehicleId, payload, region)
              : await vehicleApi.create(payload, region)

          // --- DETACH ---
          if (action === 'detach' || action === 'detach_attach') {
            const detachPayload = {
              imei: null,
              wo: this.set.workOrderNumber,
              reason: this.set.notes,
            }
            const response = await vehicleApi.update(oldVehicleId, detachPayload, region)
            if (response.status) {
              this.$toast.success(this.$t('master.tracking.move.detach.success'))
            } else {
              this.$toast.error(this.$t('master.tracking.move.detach.failed'))
              throw new Error('Detach failed')
            }
          }

          // --- ATTACH ---
          if (action === 'attach' || action === 'detach_attach') {
            const attachPayload = { ...payload, imei: this.set.imei }
            const response = await handleUpdateOrCreate(attachPayload, selectedVehicleId)
            if (response.status) {
              this.$toast.success(this.$t('master.tracking.move.attach.success'))
            } else {
              this.$toast.error(this.$t('master.tracking.move.attach.failed'))
              throw new Error('Attach failed')
            }
          }

          // --- Finalization ---
          this.isLoading = false
          this.getDevices()
          this.$bvModal.hide('device-setup')
          this.resetModal()
        } catch (err) {
          console.error('Error in Pindah Unit:', err)
          this.isLoading = false
          this.getDevices()
          this.$bvModal.hide('device-setup')
          this.resetModal()
        }
        return
      }

      // 🔧 Default PATCH request
      toolsAxios
        .patch(this.endPoint, input, config)
        .then(() => {
          this.isLoading = false
          this.$toast.success(this.message, this.optionMessage)
          this.getDevices()
          this.$bvModal.hide('device-setup')
          this.resetModal()
        })
        .catch((err) => {
          this.isLoading = false
          this.handleError(err)
        })
    },

    async onRowClicked(item) {
      this.set = {
        identifier: item.identifier,
        licensePlate: item.license_plate,
        deviceName: item.device_name,
        imei: item.imei,
        vendorType: item.vendor_type,
        phoneNo: item.phone_no,
        vehicleId: item.vehicle_id,
        domainName: item.domain_name,
        companyId: item.company_id,
        vehicleDataId: item.vehicle_id,
        selectedVgroup: item.vgroups,
        odometer: item.odometer,
        iccid: item.iccid,
        isIccidValid: item.is_iccid_valid,
      }
      this.origin = {
        identifier: item.identifier,
        licensePlate: item.license_plate,
        deviceName: item.device_name,
        imei: item.imei,
        vendorType: item.vendor_type,
        phoneNo: item.phone_no,
        vehicleId: item.vehicle_id,
        domainName: item.domain_name,
        companyId: item.company_id,
        vehicleDataId: item.vehicle_id,
        selectedVgroup: item.vgroups,
        odometer: item.odometer,
        iccid: item.iccid,
        isIccidValid: item.is_iccid_valid,
      }
      this.initialDeviceData = item
      this.imei = this.initialDeviceData?.imei

      if (item.iccid) {
        const payload = {
          phone_no: item.phone_no,
          iccid: item.iccid,
          imei: item.imei
        }
        const response = await deviceApi.iccidCheck(payload)
        if (response.status) {
          const isValid = response?.data?.data?.valid === true
          this.set.isIccidValid = isValid
          this.origin.isIccidValid = isValid
        }
      }

      this.$bvModal.show('device-setup')
    },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value
    },

    toggleAll(checked, param) {
      this.selectedModel[param] = []
      this.selected[param] = []
      if (checked) {
        for (let i = 0; i < this.devices.length; i++) {
          this.selected[param].push(i)
          this.selectedModel[param].push(true)
        }
      } else {
        for (let i = 0; i < this.devices.length; i++) {
          this.selectedModel[param].push(false)
        }
        this.selected[param] = []
      }
    },

    checkTable(event, data, param) {
      if (event) {
        this.selected[param].push(data)
      } else {
        var myIndex = this.selected[param].indexOf(data)
        if (myIndex !== -1) {
          this.selected[param].splice(myIndex, 1)
        }
      }
    },

    toDelete() {
      let promises = []
      for (let i = 0; i < this.selected.tracking.length; i++) {
        promises.push(
          this.$apollo.mutate({
            mutation: DEVICE_MUTATION_DELETE,
            variables: {
              imei: this.selected.tracking[i].imei,
            },
          })
        )
      }

      Promise.all(promises).then(() => {
        this.$apollo.queries.devices.refetch()
        this.clearDelete()
        this.$toast.success(`Data berhasil dihapus`)
      })
    },

    clearDelete() {
      this.allSelected.tracking = false
      this.selectedModel.tracking = []
      this.selected.tracking = []
    },

    cancel() {
      this.resetModal()
    },

    resetModal() {
      this.isChanging = false
      this.isChangingDevice = false
      this.isChangingSimCard = false
      this.isMirroring = false
      this.isMovingUnit = false
      this.vehicle = null
      this.optionProcess = null
      this.set = {
        companies: null,
        identifier: null,
        deviceName: null,
        imei: null,
        vendorType: null,
        phoneNo: null,
        vehicleId: null,
        newImei: null,
        workOrderNumber: '',
        notes: '',
        selectedVgroup: null,
        hullNo: null,
        vehicleYear: null,
      }
    },

    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },

    handleSubmit() {
      let input = {
        identifier: this.form.identifier,
      }
      if (this.formStatus !== 'create') {
        input = {
          oldData: { identifier: this.formOld.identifier },
          newData: input,
          imei: this.form.imei,
        }
        this.$apollo
          .mutate({
            mutation: DEVICE_MUTATION_UPDATE,
            variables: {
              input: input,
            },
          })
          .then((response) => {
            if (response) {
              if (response.data.updateDevice.isSuccessful) {
                this.$apollo.queries.devices.refetch()
                this.$toast.success(`Data berhasil diubah`)
              } else {
                var errMsg = response.data.updateDevice.message
                if (errMsg == 'Error: "User not authorized"') {
                  return this.$toast.error('Anda tidak memiliki hak akses untuk mengubah pelacak')
                } else {
                  return this.$toast.warning(response.data.updateDevice.message)
                }
              }
            }
          })
      }
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-create')
        this.resetModal()
      })
    },

    handleFailedValidation() {
      return
    },

    changeStatus(status) {
      this.status = status
      if (this.selected.tracking.length > 0) {
        this.showModal = true
      } else {
        this.$toast.error(`Minimal memilih satu atau lebih dari data di bawah.`)
      }
    },

    toChangeStatus() {
      let promises = []
      for (let i = 0; i < this.selected.tracking.length; i++) {
        promises.push(
          this.$apollo.mutate({
            mutation: DEVICE_MUTATION_UPDATE,
            variables: {
              input: {
                imei: this.selected.tracking[i].imei,
                status: this.status == 'Aktif' ? 0 : 2,
              },
            },
          })
        )
      }
      Promise.all(promises).then(() => {
        this.$toast.success(`Berhasil mengubah ${this.selected.tracking.length} status pelacak.`)
        this.showModal = false
        this.$apollo.queries.devices.refetch()
        this.clearDelete()
      })
    },

    async getDevices() {
      this.loading = true
      let payload = {
        filters: ['company_id neq 1'],
        page: this.currentPage,
        limit: this.perPage,
        search: this.filter,
      }

      if (this.selectedDomainName) {
        payload.filters = [`company_id eq ${this.selectedDomainName.id}`]
      }

      const deviceList = await deviceApi.get(payload, this.selectedServerRegion)
      if (!deviceList?.data) {
        this.filteredItems = []
        this.totalRows = 0
        this.currentPage = 1
        this.perPage = 10
        this.totalPages = 1
        this.devices = []
        this.loading = false
        return
      }

      this.devices = deviceList.data.paginated_result
      this.filteredItems = deviceList.data.paginated_result
      this.totalRows = deviceList.metadata.total_count
      this.currentPage = deviceList.metadata.page
      this.totalPages = deviceList.metadata.total_page
      this.loading = false
    },

    changePage(e) {
      this.currentPage = e
      this.getDevices()
    },

    resetFilter(e) {
      this.currentPage = 1
      this.size = e
      this.getDevices()
    },

    searchData: debounce(function () {
      this.currentPage = 1
      this.perPage = 10
      this.getDevices()
    }, 600),

    getSyncIccidPayload(filters) {
      return {
        status: 'waiting',
        filter: JSON.stringify({
          filters,
        }),
        server_region: this.selectedServerRegion,
        retry: 0,
        action: 'Sync Iccid Pelacak',
      }
    },

    async requestSyncIccidByImei(item) {
      const imei = item?.imei

      if (!imei) {
        this.$toast.error('IMEI tidak ditemukan')
        return
      }

      const payload = this.getSyncIccidPayload(["imei eq '" + imei + "'"])

      try {
        await smsAxios.post('/device/sync/iccid', payload)
        this.$toast.success('Request sync ICCID untuk IMEI ' + imei + ' berhasil dikirim')
      } catch (error) {
        this.handleError(error)
      }
    },

    async requestSyncIccid() {
      this.isLoading = true
      const filters = this.selectedDomainName
        ? [`company_id eq ${this.selectedDomainName.id}`]
        : ['company_id neq 1']
      const payload = this.getSyncIccidPayload(filters)

      try {
        await smsAxios.post('/device/sync/iccid', payload)
        this.$toast.success('Request sync ICCID berhasil dikirim')
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
      }
    },

    async exportDevice() {
      this.isLoading = true

      let payload = {
        filters: ['company_id neq 1'],
        page: 1,
        limit: this.totalRows,
        search: this.filter,
      }

      if (this.selectedDomainName) {
        payload.filters = [`company_id eq ${this.selectedDomainName.id}`]
      }

      try {
        await deviceApi.download(payload, this.selectedServerRegion)

        this.isLoading = false
        this.$toast.info('Export start')
        return
      } catch (err) {
        this.handleError(err)
        this.isLoading = false
      }
    },

    async syncERP(item) {
      this.isLoading = true
      let params = {
        page: 1,
        limit: this.totalRows,
      }

      const headers = {
        'X-Region': this.selectedServerRegion,
      }

      if (this.selectedDomainName) {
        params.filters = [`company_id eq ${this.selectedDomainName.id}`]
      }

      if (item) {
        params.filters = [`imei eq '${item.imei}'`]
      }

      const syncDeviceResponse = await syncDevices.get(params, headers)

      if (syncDeviceResponse.status == 200) {
        this.$toast.success('Berhasil sinkronisasi data pelacak')
      } else {
        this.$toast.error('Gagal sinkronisasi data pelacak')
      }

      this.isLoading = false
    },

    async onServerRegionChange() {
      this.currentPage = 1
      this.perPage = 10
      await this.getDevices()
    },

    async onInputMoveType() {
      // hanya lanjut kalau pilihannya attach atau detachattach
      if (this.set.actionType === 'attach' || this.set.actionType === 'detach_attach') {
        await this.fetchVgroups()
        const params = {
          filters: [`company_id eq ${this.initialDeviceData.company_id}`, `imei is null`],
          limit: 1,
        }

        let response = await vehicleApi.get(params)
        const totalCount = response.metadata.total_count

        params.limit = totalCount
        response = await vehicleApi.get(params)
        this.vehicleOptions = response.data.paginated_result
      } else {
        // reset data kendaraan kalau bukan attach/detachattach
        this.vehicleOptions = []
        this.set.selectedVehicle = null
        this.set.selectedVehicleType = null
      }
    },

    async onVehicleSelect(vehicle) {
      const params = {
        filters: [`company_id eq 1`],
        limit: 1,
      }
      let response = await toolsVehicleApi.getVehicleType(params)
      const totalCount = response.metadata.total_count
      params.limit = totalCount
      response = await toolsVehicleApi.getVehicleType(params)
      const vehicleTypes = response.data.paginated_result
      this.vehicleTypes = vehicleTypes
      this.vehicleTypeOptions = vehicleTypes
      this.set.odometer = vehicle.odometer / 1000
      if (vehicle.vehicle_type_id) {
        this.set.selectedVehicleType = this.vehicleTypes.find(
          (data) => data.vehicle_type_id === vehicle.vehicle_type_id
        )
      }
      this.set.hullNo = vehicle.hull_no
      this.set.selectedVgroup = vehicle.vgroups
    },

    async onCompanySelect() {
      const params = {
        filters: [`company_id eq ${this.set.companies.id}`, `imei is null`],
        limit: 1,
      }

      let response = await vehicleApi.get(params)
      const totalCount = response.metadata.total_count

      params.limit = totalCount
      response = await vehicleApi.get(params)
      this.vehicleOptions = response.data.paginated_result
    },

    async addVehicleTag(newValue) {
      if (!newValue || !newValue.trim()) return

      const trimmedValue = newValue.trim()

      // // 🚫 Validasi: tidak boleh sama dengan licensePlate utama
      // if (trimmedValue === this.set.licensePlate) {
      //   // Tandai error di Vuelidate
      //   if (this.$v?.set?.selectedVehicle) {
      //     this.$v.set.selectedVehicle.$touch()
      //   }

      //   // Tambahkan pesan error manual agar muncul di bawah field
      //   this.customVehicleError = this.$t('Nomor plat tidak boleh sama dengan kendaraan utama')

      //   return
      // }

      // Jika valid, hapus pesan error custom
      this.customVehicleError = null

      const tag = {
        license_plate: trimmedValue,
        vehicle_id: 0,
        vehicle_type_id: 0,
        odometer: parseInt(this.set.odometer || 0),
        hull_no: this.set.hullNo || null,
      }

      this.vehicleOptions.push(tag)
      this.set.selectedVehicle = tag
      this.set.selectedVgroup = this.origin.selectedVgroup

      // 🔧 Reset error validasi agar hilang
      if (this.$v?.set?.selectedVehicle) {
        this.$v.set.selectedVehicle.$reset()
      }

      try {
        const params = { filters: [`company_id eq 1`], limit: 1 }
        let response = await toolsVehicleApi.getVehicleType(params)
        const totalCount = response.metadata?.total_count || 0

        if (totalCount > 0) {
          params.limit = totalCount
          response = await toolsVehicleApi.getVehicleType(params)
          this.vehicleTypeOptions = response.data?.paginated_result || []

          if (this.vehicleTypes.length > 0) {
            this.set.selectedVehicle.vehicle_type_id = this.vehicleTypes[0].vehicle_type_id
          }
        }
      } catch (err) {
        console.error('Gagal mengambil vehicle types:', err)
      }
    },

    async changeTransferMode(mode) {
      // ✅ simpan state lama (opsional tapi bagus)
      // this.formCache[this.transferMode] = { ...this.set }
      this.formCache[this.transferMode] = JSON.parse(JSON.stringify(this.set))

      this.transferMode = mode

      // ✅ restore kalau pernah ada
      if (this.formCache[mode]) {
        this.set = {
          ...this.set,
          ...this.formCache[mode],
        }
      }

      // reset validasi aja
      if (this.$v?.set) {
        this.$v.set.$reset()
      }

      await this.$nextTick()
    },

    async fetchVgroups() {
      const params = {
        limit: 1,
        page: 1,
        filters: [`company_id eq ${this.set.companyId}`],
      }
      let response = await vgroupsApi.get(params)
      if (response.status) {
        if (response.metadata.total_count > 1) {
          params.limit = response.metadata.total_count
        }
        response = await vgroupsApi.get(params)
        if (response.status) {
          this.vgroupOptions = response.data.paginated_result
        }
      }
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <p class="mb-4">{{ $t('master.textTracker') }}</p>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Filter Card Wrapper -->
            <div class="card mb-3 filter-card">
              <div class="card-body p-3">
                <!-- Top Row: Region & Company & Search -->
                <div class="row mb-3 pb-3 border-bottom">
                  <div class="col-12">
                    <div class="filter-top-wrapper">
                      <!-- Region Select -->
                      <b-form-select
                        class="form-select form-select-md __limit--dropdown filter-region-select"
                        v-model="selectedServerRegion"
                        @change="onServerRegionChange"
                        style="max-width: 180px"
                      >
                        <b-form-select-option value="SG">Singapura</b-form-select-option>
                        <b-form-select-option value="ID">Indonesia</b-form-select-option>
                      </b-form-select>

                      <!-- Company Select -->
                      <multiselect
                        class="filter-company-select"
                        v-model="selectedDomainName"
                        :options="companies.companies"
                        placeholder="Perusahaan"
                        :custom-label="customLabel"
                        style="max-width: 1000px"
                      />

                      <!-- Search Input - Prominent Style -->
                      <div class="filter-search-box ms-auto">
                        <i class="mc-fa fas fa-search"></i>
                        <b-form-input
                          v-model="filter"
                          type="search"
                          :placeholder="$t('global.search') + '...'"
                          class="filter-search-input"
                          @input="searchData"
                        ></b-form-input>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Bottom Row: Action Buttons -->
                <div class="row">
                  <div class="col-12">
                    <div class="filter-button-group">
                      <!-- SINKRONISASI Label -->
                      <span class="text-muted fw-bold small">SINKRONISASI</span>

                      <!-- Sync Button -->
                      <b-dropdown
                        variant="primary"
                        text="Sync Data"
                        right
                        size="md"
                        v-if="flagSyncErp || hasAccessAll(['sync_vehicle_log:create'])"
                        :disabled="isLoading"
                      >
                        <template #button-content>
                          <b-spinner v-if="isLoading" small type="grow" class="mr-2"></b-spinner>
                          <i v-else class="fas fa-sync-alt mr-2"></i>
                          Sync Data
                        </template>

                        <!-- Sync ERP -->
                        <b-dropdown-item-button
                          v-if="hasAccessAll(['sync_vehicle_log:create']) && flagSyncErp"
                          @click="syncERP(null)"
                          v-b-tooltip.hover.right="
                            'sync nopol ke ERP mengacu domain dan imei, filter nama company sebelum klik sync ERP'
                          "
                        >
                          <i class="fas fa-sync-alt mr-2"></i>
                          {{ $t('tracking.syncERP') }}
                        </b-dropdown-item-button>

                        <!-- Sync ICCID -->
                        <b-dropdown-item-button
                          v-if="hasAccessAll(['sms-sync-iccid:create'])"
                          @click="requestSyncIccid"
                          :disabled="isLoading"
                          v-b-tooltip.hover.right="
                            'sync ICCID untuk semua company selain McEasy Default'
                          "
                        >
                          <b-spinner v-if="isLoading" small type="grow" class="mr-2"></b-spinner>
                          <i v-else class="fas fa-sync-alt mr-2"></i>
                          Sync ICCID to ERP
                        </b-dropdown-item-button>
                      </b-dropdown>

                      <!-- Logs Button -->
                      <b-dropdown variant="primary" text="Logs" right size="md">
                        <template #button-content>
                          <b-spinner v-if="isLoading" small type="grow" class="mr-2"></b-spinner>
                          <i v-else class="fas fa-list mr-2"></i>
                          Log Data
                        </template>

                        <!-- Sync Vehicle Log -->
                        <b-dropdown-item-button
                          v-if="hasAccessAll(['sync_vehicle_log:read']) && flagSyncErp"
                          @click="syncVehicleLogModal = true"
                          v-b-tooltip.hover.right="'hasil dari proses Sync ERP'"
                        >
                          <i class="fas fa-sync-alt mr-2"></i>
                          {{ $t('tracking.syncVehicleLog') }}
                        </b-dropdown-item-button>

                        <!-- Sync ICCID Log -->
                        <b-dropdown-item-button
                          v-if="hasAccessAll(['sms-sync-iccid:read'])"
                          @click="syncIccidLogModal = true"
                          v-b-tooltip.hover.right="'hasil request sync ICCID'"
                        >
                          <i class="fas fa-history mr-2"></i>
                          Sync ICCID Log
                        </b-dropdown-item-button>

                        <!-- Sync Pindah Domain -->
                        <b-dropdown-item-button
                          v-if="hasAccessAll(['sms-move-vehicle-company-log:read'])"
                          @click="syncMoveVehicleCompanyLogModal = true"
                          v-b-tooltip.hover.right="
                            'hasil dari proses pindah domain beserta kendaraannya'
                          "
                        >
                          <i class="fas fa-arrows-alt mr-2"></i>
                          Sync Pindah Domain
                        </b-dropdown-item-button>
                      </b-dropdown>

                      <div class="vr"></div>

                      <!-- DATA Label -->
                      <span class="text-muted fw-bold small">DATA</span>

                      <!-- Multi IMEI Button -->
                      <McButton
                        v-if="hasAccessAll(['sms-device-multi-imei:read'])"
                        variant="secondary"
                        :text="$t('device.multiImei')"
                        size="md"
                        icon="fas fa-list"
                        icon-position="left"
                        @click="() => this.$router.push({ name: 'Master Multi Imei' })"
                        v-b-tooltip.hover.bottom="'shortcut ke menu multi imei'"
                      />

                      <!-- Export Vehicle Log Button -->
                      <McButton
                        variant="secondary"
                        text="Export Vehicle Log"
                        size="md"
                        icon="fas fa-download"
                        icon-position="left"
                        @click="exportVehicleLogModal = true"
                        v-b-tooltip.hover.bottom="
                          'hasil file unduhan setelah klik export dari halaman pelacak'
                        "
                      />

                      <!-- Export Button (secondary - Right side) -->
                      <McButton
                        :disabled="!(devices.length > 0) || isLoading"
                        variant="secondary"
                        :text="$t('global.export')"
                        size="md"
                        :icon="isLoading ? '' : 'fas fa-download'"
                        icon-position="left"
                        @click="exportDevice"
                        class="ms-auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Selected Rows Info -->
            <div v-if="selected.tracking.length" class="row mb-3">
              <div class="col-12">
                <h6 class="mc-row-check">
                  <span class="badge btn-success">{{ selected.tracking.length }}</span>
                  Baris terpilih.
                  <a class="color-primary" @click="clearDelete">Bersihkan semua</a>
                </h6>
              </div>
            </div>

            <!-- Table Tracking -->
            <div class="table-responsive my-3 border border-1">
              <b-table
                class="datatables"
                :items="devices"
                :fields="visibleFields"
                show-empty
                :empty-text="$t('global.emptyTable')"
                :empty-filtered-text="$t('global.emptyFilteredTable')"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :busy="loading"
                @hidden="resetModal"
                @row-clicked="onRowClicked"
                stickyHeader
              >
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <template #head(columnCheck)>
                  <div class="form-check">
                    <b-form-checkbox
                      @change="toggleAll($event, 'tracking')"
                      v-model="allSelected.tracking"
                      :indeterminate="indeterminate.tracking"
                      :value="true"
                      :unchecked-value="false"
                      :disabled="!getAccessRight()"
                    ></b-form-checkbox>
                  </div>
                </template>

                <template #cell(columnCheck)="data">
                  <div class="form-check">
                    <b-form-checkbox
                      @change="checkTable($event, data.item, 'tracking')"
                      v-model="selectedModel.tracking[data.index]"
                      :value="true"
                      :unchecked-value="false"
                      :disabled="!getAccessRight()"
                    ></b-form-checkbox>
                  </div>
                </template>
                <template #cell(view)="data">
                  <div class="button-items" style="text-align: center">
                    <b-button
                      id="tooltip-set-to"
                      :disabled="!data.item.vehicle_id"
                      variant="me-3 btn-outline-primary"
                      @click="viewConfig(data.item)"
                      ><i class="mc-fa icon-outline_Pin-History"></i>
                    </b-button>
                    <b-tooltip target="tooltip-set-to" placement="top" title="View"> </b-tooltip>
                  </div>
                </template>
                <template #cell(syncIccid)="data">
                  <div class="button-items" style="text-align: center">
                    <b-button
                      variant="me-3 btn-outline-primary"
                      @click.stop="requestSyncIccidByImei(data.item)"
                      v-b-tooltip.hover.top="'Sync ICCID'"
                    >
                      <i class="fas fa-sync-alt"></i>
                    </b-button>
                  </div>
                </template>
                <template #cell(identifier)="data">
                  <strong class="text-primary">
                    {{ data.item.identifier }}
                  </strong>
                </template>
                <template #cell(imei)="data">
                  <strong class="text-primary">
                    {{ data.item.imei }}
                  </strong>
                </template>
                <!-- Kolom ICCID -->
                <template #cell(iccid)="data">
                  <span v-if="data.item.iccid">{{ data.item.iccid }}</span>
                  <span v-else class="text-muted"> Belum terbaca </span>
                </template>

                <template #cell(phone_no)="data">
                  <span class="d-inline-flex gap-1 text-nowrap">
                    <span
                      v-if="data.item.iccid && data.item.is_iccid_valid"
                      class="text-success"
                      title="ICCID valid"
                    >
                      <i class="fas fa-check-circle" />
                    </span>
                    <span
                      v-else-if="data.item.iccid && !data.item.is_iccid_valid"
                      class="text-warning"
                      title="ICCID tidak valid"
                    >
                      <i class="fas fa-exclamation-triangle" />
                    </span>
                    <span v-else class="text-muted" title="ICCID belum terbaca">
                      <i class="icon-outline_minus-circle" />
                    </span>
                    <span>{{ data.item.phone_no || '-' }}</span>
                  </span>
                </template>
                <template #cell(assigned_on)="data">
                  {{ data.item.assigned_on ? formatDateUtc(data.item.assigned_on) : '-' }}
                </template>
                <template #cell(last_receive)="data">
                  {{ data.item.last_receive ? formatDateUtc(data.item.last_receive) : '-' }}
                </template>
                <template #cell(battery)="data">
                  <span v-if="data.item.battery !== null">{{ data.item.battery }}</span>
                  <span v-else>-</span>
                </template>
                <template #cell(latitude)="data">
                  <span v-if="data.item.latitude !== null">{{ data.item.latitude }}</span>
                  <span v-else>-</span>
                </template>
                <template #cell(signal_status)="data">
                  <b-badge :class="getSignalType(data).bg">
                    <i :class="`mc-fa icon-fill_signal-${getSignalType(data).icon} me-2`"></i>
                    <span :class="getSignalType(data).color">{{ getSignalType(data).text }}</span>
                  </b-badge>
                </template>
                <template #cell(live_view_status)="data">
                  <div :class="getLiveViewStatus(data.item.motion_status).bg">
                    <span class="text-white">{{
                      getLiveViewStatus(data.item.motion_status).text
                    }}</span>
                  </div>
                </template>
                <template #cell(is_support_adas)="data">
                  {{
                    data.item.is_support_adas === true
                      ? $t('global.yes')
                      : data.item.is_support_adas === false
                      ? $t('global.no')
                      : '-'
                  }}
                </template>
                <template #cell(door_sensor)="data">
                  {{
                    data.item.door_sensor === true
                      ? $t('global.yes')
                      : data.item.door_sensor === false
                      ? $t('global.no')
                      : '-'
                  }}
                </template>
                <template #cell(fuel_sensor)="data">
                  {{
                    data.item.fuel_sensor === true
                      ? $t('global.yes')
                      : data.item.fuel_sensor === false
                      ? $t('global.no')
                      : '-'
                  }}
                </template>
                <template #cell(temperature_sensor)="data">
                  {{
                    data.item.temperature_sensor === true
                      ? $t('global.yes')
                      : data.item.temperature_sensor === false
                      ? $t('global.no')
                      : '-'
                  }}
                </template>
                <template #cell(is_support_dms)="data">
                  {{
                    data.item.is_support_dms === true
                      ? $t('global.yes')
                      : data.item.is_support_dms === false
                      ? $t('global.no')
                      : '-'
                  }}
                </template>
                <template #cell(is_multi_imei)="data">
                  <b-form-checkbox
                    v-model="data.item.is_multi_imei"
                    :value="true"
                    :unchecked-value="false"
                    @change.prevent
                    class="readonly-checkbox"
                  ></b-form-checkbox>
                </template>
                <template #cell(longitude)="data">
                  <span v-if="data.item.longitude !== null">{{ data.item.longitude }}</span>
                  <span v-else>-</span>
                </template>
                <template #cell(engine_on)="data">
                  <span v-if="data.item?.engine_on === null">-</span>
                  <span v-else>
                    <span class="mc-status mc-status--green" v-if="data.item.engine_on === true">
                      {{ $t('global.on') }}
                    </span>
                    <span v-else class="mc-status mc-status--red">
                      {{ $t('global.off') }}
                    </span>
                  </span>
                </template>
                <template #cell(motion_status)="data">
                  {{ data.item.motion_status ? '' : '-' }}
                  <span class="mc-status mc-status--green" v-if="data.item.motion_status === `M`">
                    {{ $t('vehicle.motionStatus.inMotion') }}
                  </span>
                  <span
                    class="mc-status mc-status--grey"
                    v-else-if="data.item.motion_status === `U`"
                  >
                    {{ $t('vehicle.motionStatus.unknown') }}
                  </span>
                  <span
                    class="mc-status mc-status--grey"
                    v-else-if="data.item.motion_status === `O`"
                  >
                    {{ $t('vehicle.motionStatus.offline') }}
                  </span>

                  <span
                    class="mc-status mc-status--red"
                    v-else-if="data.item.motion_status === `P`"
                  >
                    {{ $t('vehicle.motionStatus.parked') }}
                  </span>
                  <span
                    class="mc-status mc-status--blue"
                    v-else-if="data.item.motion_status === `A`"
                  >
                    {{ $t('vehicle.motionStatus.assisted') }}
                  </span>
                  <span
                    class="mc-status mc-status--yellow"
                    v-else-if="data.item.motion_status === `I`"
                  >
                    {{ $t('vehicle.motionStatus.idle') }}
                  </span>
                </template>
                <template #cell(speed)="data">
                  <span v-if="data.item.speed !== null">{{ data.item.speed }}</span>
                  <span v-else>-</span>
                </template>

                <template #cell(device_status)="data">
                  <span class="mc-status mc-status--green" v-if="data.item.device_status === true">
                    {{ $t('device.active') }}
                  </span>
                  <span class="mc-status mc-status--grey" v-else>
                    {{ $t('device.archive') }}
                  </span>
                </template>
                <template #cell(sync_device)="data">
                  <b-button variant="primary" size="sm" @click="syncERP(data.item)">
                    Sync
                  </b-button>
                </template>
              </b-table>
            </div>

            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <span>Menampilkan</span>
                    <span>
                      <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                        @change="resetFilter"
                      />
                    </span>
                    <span>entri.&nbsp;&nbsp;</span>
                    <span
                      >Menampilkan&nbsp;
                      <strong>
                        {{ filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0 }}
                      </strong>
                      &nbsp;sampai&nbsp;
                      <strong>
                        {{
                          currentPage != totalPages
                            ? currentPage * perPage
                            : (currentPage - 1) * perPage + filteredItems.length
                        }}
                      </strong>
                      &nbsp;dari&nbsp;
                      <strong>{{ totalRows }}</strong>
                      &nbsp;entri.
                    </span>
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      @change="changePage"
                    />
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="device-setup"
      ref="device-setup"
      size="lg"
      title="Set Pelacak"
      @hidden="resetModal"
      centered
    >
      <b-row>
        <!-- IMEI -->
        <b-col :md="isMovingUnit ? 4 : 6">
          <div class="mb-3">
            <span class="d-block">IMEI</span>
            <strong>{{ origin.imei }}</strong>
          </div>
        </b-col>
        <!-- Vendor -->
        <b-col :md="isMovingUnit ? 4 : 6">
          <div class="mb-3">
            <span class="d-block">Vendor</span>
            <strong>{{ origin.vendorType }}</strong>
          </div>
        </b-col>

        <b-col v-if="isMovingUnit" md="4">
          <div class="mb-3">
            <span class="d-block">Domain</span>
            <strong>{{ origin.domainName }}</strong>
          </div>
        </b-col>

        <!-- Tipe Perangkat -->
        <b-col :md="isMovingUnit ? 4 : 6">
          <div class="mb-3">
            <span class="d-block">Tipe Perangakat</span>
            <strong>{{ origin.deviceName }}</strong>
          </div>
        </b-col>

        <!-- Plat Nomor -->
        <b-col :md="isMovingUnit ? 4 : 6">
          <div class="mb-3">
            <span class="d-block">Nopol Asal</span>
            <strong>{{ origin.licensePlate }}</strong>
          </div>
        </b-col>

        <!-- Nomor SIMCard -->
        <b-col :md="isMovingUnit ? 4 : 6">
          <div class="mb-3">
            <span class="d-block">Nomor SIMCard</span>
            <strong>
              <span class="d-inline-flex align-items-center gap-1 text-nowrap">
                <!-- Ikon validasi -->
                <span
                  v-if="origin.iccid && origin.isIccidValid"
                  class="text-success"
                  title="ICCID valid"
                >
                  <i class="fas fa-check-circle" />
                </span>
                <span
                  v-else-if="origin.iccid && !origin.isIccidValid"
                  class="text-warning"
                  title="ICCID tidak valid"
                >
                  <i class="fas fa-exclamation-triangle" />
                </span>
                <span v-else class="text-muted" title="ICCID belum terbaca">
                  <i class="icon-outline_minus-circle" />
                </span>
                <!-- Nomor -->
                <span>{{ origin.phoneNo || '-' }}</span>
              </span>
              <!-- Teks tambahan -->
              <span v-if="origin.iccid && !origin.isIccidValid" class="text-warning ms-1">
                Tidak valid
              </span>
              <span v-else-if="!origin.iccid" class="text-muted ms-1"> (Belum terbaca) </span>
            </strong>
          </div>
        </b-col>

        <!-- ododmeter awal -->
        <b-col :md="isMovingUnit ? 4 : 6">
          <div class="mb-3">
            <span class="d-block">Odometer Asal</span>
            <strong>
              {{
                origin.odometer != null
                  ? (origin.odometer / 1000).toFixed(2).replace('.', ',') + ' km'
                  : '-'
              }}
            </strong>
          </div>
        </b-col>

        <b-col md="12">
          <div class="mb-2">
            <label :for="`${componentId}-select-process`">{{
              $t('setting.modal.selectProcess')
            }}</label>
            <multiselect
              :id="`${componentId}-select-process`"
              data-testid="select-process"
              v-model="optionProcess"
              :options="processOptions"
              :multiple="false"
              :placeholder="$t('setting.modal.choose')"
              @input="selectProcess"
            />
          </div>

          <!-- Process Description -->
          <div v-if="optionProcess" class="mb-3 p-3 border-start border-primary border-4 bg-light">
            <p class="mb-0 text-muted">{{ getProcessDescription(optionProcess) }}</p>
          </div>
        </b-col>
      </b-row>

      <!-- 🎯 SATU FORMULATE FORM TERPUSAT UNTUK SEMUA PROCESS -->
      <FormulateForm
        v-if="optionProcess"
        v-model="set"
        @submit="saveProcess"
        :key="`form-${optionProcess}`"
        @failed-validation="handleFailedValidation"
      >
        <!-- ========== GANTI PERANGKAT ========== -->
        <div v-show="isChangingDevice" :id="`${componentId}-section-change-device`">
          <div class="mb-2">
            <FormulateInput
              :id="`${componentId}-input-new-imei`"
              data-testid="input-new-imei"
              mt="2"
              v-model="formNewImei"
              type="select-resourceful-v2"
              :label="$t('setting.modal.selectNewImei')"
              name="newImei"
              :placeholder="$t('setting.modal.choose')"
              :optionsGetter="getVehiclesFromVehicleStatus"
              :optionLabelFn="({ item }) => item.imei"
              class="pt-0"
              trackBy="imei"
              validation="required"
              :validation-messages="{ required: $t('setting.modal.requiredChooseImei') }"
              validation-behavior="live"
              error-behavior="live"
              :fullObject="setNewImei"
              @update:fullObject="
                (val) => {
                  setNewImei = val
                  set.newImei = val
                }
              "
            />
          </div>
        </div>

        <!-- ========== GANTI SIMCARD ========== -->
        <div v-show="isChangingSimCard" :id="`${componentId}-section-change-sim`">
          <FormulateInput
            :id="`${componentId}-input-phone`"
            data-testid="input-phone"
            type="number"
            name="phoneNo"
            :label="$t('setting.modal.newSimcard')"
            :placeholder="$t('setting.modal.changeWithNewSimCard')"
            :validation="['required']"
            :validation-messages="{
              required: `${$t('setting.modal.newSimcard')} ${$t('setting.modal.required')}`,
            }"
            validation-behavior="live"
            error-behavior="live"
            @keydown="portKeydown($event, (preventZeroFirst = true))"
          />
        </div>

        <!-- ========== PINDAH COMPANY ========== -->
        <div v-show="isChanging" :id="`${componentId}-section-move-company`">
          <div class="mb-3">
            <label class="required">Pilih Mode Pemindahan</label>
            <div class="d-flex gap-3">
              <!-- Mode 1 -->
              <div
                :id="`${componentId}-mode-device-vehicle`"
                data-testid="mode-device-vehicle"
                class="mode-card"
                :class="{ active: transferMode === 'device_vehicle' }"
                @click="changeTransferMode('device_vehicle')"
              >
                <input type="radio" value="device_vehicle" v-model="transferMode" class="d-none" />
                <div class="p-3 border rounded text-center">
                  <div class="mode-icon mb-2">
                    <i class="bi bi-truck fs-2 text-warning"></i>
                  </div>
                  <strong>Perangkat & Kendaraan</strong>
                  <div class="text-muted small">
                    <div class="mb-2">Pindahkan perangkat beserta kendaraan ke domain baru</div>
                    <div>Sensor, Kamera, dan Trip history akan berpindah ke domain baru</div>
                  </div>
                </div>
              </div>

              <!-- Mode 2 -->
              <div
                :id="`${componentId}-mode-device-only`"
                data-testid="mode-device-only"
                class="mode-card"
                :class="{ active: transferMode === 'device_only' }"
                @click="changeTransferMode('device_only')"
              >
                <input type="radio" value="device_only" v-model="transferMode" class="d-none" />
                <div class="p-3 border rounded text-center">
                  <div class="mode-icon mb-2">
                    <i class="bi bi-cpu fs-2 text-primary"></i>
                  </div>
                  <strong>Perangkat Saja</strong>
                  <div class="text-muted small">
                    <div class="mb-2">Pindahkan perangkat ke kendaraan lain di domain baru</div>
                    <div>
                      Sensor dan Kamera akan dicopy ke kendaraan baru. Trip history tidak akan
                      berpindah
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Target Company -->
          <div class="mb-2">
            <label class="required" :for="`${componentId}-target-company`">
              {{ $t('setting.modal.targetCompany') }}
            </label>
            <multiselect
              :id="`${componentId}-target-company`"
              data-testid="target-company"
              v-model="set.companies"
              :options="companies.companies"
              placeholder="Pilih Company"
              :custom-label="customLabel"
              :class="{ 'is-invalid': $v.set.companies.$error }"
              @input="onCompanySelect"
            />
            <div v-if="$v.set.companies.$error" class="invalid-feedback mt-0">
              <span v-if="!$v.set.companies.required">
                {{ $t('setting.modal.targetCompany') }} Wajib Terisi
              </span>
            </div>
          </div>

          <template v-if="transferMode === 'device_only'">
            <!-- Vehicle -->
            <div class="mb-2">
              <label class="required" :for="`${componentId}-new-license-plate`">
                {{ $t('setting.modal.newLicensePlate') }}
              </label>

              <multiselect
                :id="`${componentId}-new-license-plate`"
                data-testid="new-license-plate"
                v-model="set.selectedVehicle"
                :options="vehicleOptions"
                label="license_plate"
                track-by="vehicle_id"
                placeholder="Pilih Kendaraan"
                @input="onVehicleSelect"
                :taggable="true"
                @tag="addVehicleTag"
                :class="{ 'is-invalid': $v.set.selectedVehicle.$error || customVehicleError }"
              />

              <div
                v-if="$v.set.selectedVehicle.$error || customVehicleError"
                class="invalid-feedback mt-0"
              >
                <span v-if="customVehicleError">{{ customVehicleError }}</span>
                <span v-if="!$v.set.selectedVehicle.required">
                  {{ $t('setting.modal.newLicensePlate') }} Wajib Terisi
                </span>
              </div>
            </div>

            <!-- Simcard -->
            <div class="mb-2">
              <label class="required" :for="`${componentId}-phone-device-only`">
                {{ $t('setting.modal.newSimcard') }}
              </label>
              <FormulateInput
                :id="`${componentId}-phone-device-only`"
                data-testid="phone-device-only"
                :key="'phone-' + transferMode"
                v-model="set.phoneNo"
                type="number"
                name="phoneNo"
                placeholder="Ganti dengan Simcard baru"
                :validation="['required']"
                :validation-messages="{
                  required: `${this.$t('setting.modal.newSimcard')} Wajib Terisi`,
                }"
                validation-behavior="live"
                error-behavior="live"
                @keydown="portKeydown($event, (preventZeroFirst = true))"
              />
            </div>

            <div class="mb-2">
              <label class="required" :for="`${componentId}-vehicle-type`">
                {{ $t('setting.modal.vehicleType') }}
              </label>
              <multiselect
                :id="`${componentId}-vehicle-type`"
                data-testid="vehicle-type"
                v-model="set.selectedVehicleType"
                :options="vehicleTypeOptions"
                label="vehicle_type"
                track-by="vehicle_type_id"
                placeholder="Pilih Jenis Kendaraan"
                :class="{ 'is-invalid': $v.set.selectedVehicleType.$error }"
              />
              <div v-if="$v.set.selectedVehicleType.$error" class="invalid-feedback mt-0">
                <span v-if="!$v.set.selectedVehicleType.required">
                  {{ $t('setting.modal.vehicleType') }} Wajib Terisi
                </span>
              </div>
            </div>

            <!-- Odometer -->
            <div class="mb-2">
              <label class="required" :for="`${componentId}-odo`">Odometer</label>
              <FormulateInput
                :id="`${componentId}-odo`"
                data-testid="odo"
                type="number"
                name="odo"
                placeholder="Masukkan Odometer (Km)"
                mt="2"
                :validation="['required']"
                :validation-messages="{ required: 'Odometer Wajib Terisi' }"
                @keydown="portKeydown($event)"
              />
            </div>

            <FormulateInput
              :id="`${componentId}-vehicle-year`"
              data-testid="vehicle-year"
              type="number"
              name="vehicleYear"
              label="Tahun Kendaraan"
              placeholder="Masukkan Tahun Kendaraan"
              mt="2"
              @keydown="portKeydown($event)"
            />

            <FormulateInput
              :id="`${componentId}-hull-no`"
              data-testid="hull-no"
              type="text"
              name="hullNo"
              label="Nomor Lambung"
              placeholder="Masukkan Nomor Lambung"
              mt="2"
            />
          </template>
        </div>

        <!-- ========== MIRRORING ========== -->
        <div v-show="isMirroring" :id="`${componentId}-section-mirroring`">
          <div class="mb-2">
            <label class="required" :for="`${componentId}-target-company-mirror`">
              {{ $t('setting.modal.targetCompany') }}
            </label>
            <multiselect
              :id="`${componentId}-target-company-mirror`"
              data-testid="target-company-mirror"
              v-model="set.companies"
              :options="companies.companies"
              placeholder="Pilih Company"
              :custom-label="customLabel"
              :class="{ 'is-invalid': $v.set.companies.$error }"
            />
            <div v-if="$v.set.companies.$error" class="invalid-feedback mt-0">
              <span v-if="!$v.set.companies.required">
                {{ $t('setting.modal.targetCompany') }} Wajib Terisi
              </span>
            </div>
          </div>
        </div>

        <!-- ========== PINDAH UNIT ========== -->
        <div v-show="isMovingUnit" :id="`${componentId}-section-move-unit`">
          <div class="mt-2 radio-group-inline">
            <McRadioButton
              v-if="hasAccessAll(['sms-device-move:update']) && set.vehicleDataId"
              :id="`${componentId}-radio-detach`"
              data-testid="radio-detach"
              key="detach"
              v-model="set.actionType"
              name="actionType"
              initialValue="detach"
              :label="$t('master.tracking.detach')"
              @input="onInputMoveType"
            />
            <McRadioButton
              v-if="
                hasAccessAll(['sms-device-move:update']) &&
                hasAccessAll(['sms-device-move:create']) &&
                !set.vehicleDataId
              "
              :id="`${componentId}-radio-attach`"
              data-testid="radio-attach"
              key="attach"
              v-model="set.actionType"
              name="actionType"
              initialValue="attach"
              :label="$t('master.tracking.attach')"
              @input="onInputMoveType"
            />
            <McRadioButton
              v-if="
                hasAccessAll(['sms-device-move:update']) &&
                hasAccessAll(['sms-device-move:create']) &&
                set.vehicleDataId
              "
              :id="`${componentId}-radio-detach-attach`"
              data-testid="radio-detach-attach"
              key="detach_attach"
              v-model="set.actionType"
              name="actionType"
              initialValue="detach_attach"
              :label="$t('master.tracking.detachAttach')"
              @input="onInputMoveType"
            />
          </div>

          <!-- tampilkan hanya jika attach atau detachattach -->
          <div
            class="mt-2"
            v-if="set.actionType === 'attach' || set.actionType === 'detach_attach'"
          >
            <div class="mb-2">
              <label class="required" :for="`${componentId}-new-license-plate-move`">
                {{ $t('setting.modal.newLicensePlate') }}
              </label>
              <multiselect
                :id="`${componentId}-new-license-plate-move`"
                data-testid="new-license-plate-move"
                v-model="set.selectedVehicle"
                :options="vehicleOptions"
                label="license_plate"
                track-by="vehicle_id"
                placeholder="Pilih Kendaraan"
                @input="onVehicleSelect"
                :taggable="true"
                @tag="addVehicleTag"
                :class="{ 'is-invalid': $v.set.selectedVehicle.$error || customVehicleError }"
              />
              <div
                v-if="$v.set.selectedVehicle.$error || customVehicleError"
                class="invalid-feedback mt-0"
              >
                <span v-if="customVehicleError">{{ customVehicleError }}</span>
                <span v-if="!$v.set.selectedVehicle.required">
                  {{ $t('setting.modal.newLicensePlate') }} Wajib Terisi
                </span>
              </div>
            </div>

            <div class="mb-2">
              <label class="required" :for="`${componentId}-vgroup`">
                {{ $t('setting.modal.vgroup') }}
              </label>
              <multiselect
                :id="`${componentId}-vgroup`"
                data-testid="vgroup"
                v-model="set.selectedVgroup"
                :options="vgroupOptions"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                :hide-selected="true"
                :allow-empty="true"
                placeholder="Pilih Group Kendaraan"
                label="name"
                track-by="vgroup_id"
                :class="{ 'is-invalid': $v.set.selectedVgroup.$error }"
              />
              <div v-if="$v.set.selectedVgroup.$error" class="invalid-feedback mt-0">
                <span v-if="!$v.set.selectedVgroup.required">
                  {{ $t('setting.modal.vgroup') }} Wajib Terisi
                </span>
              </div>
            </div>

            <div class="mb-2">
              <label class="required" :for="`${componentId}-vehicle-type-move`">
                {{ $t('setting.modal.vehicleType') }}
              </label>
              <multiselect
                :id="`${componentId}-vehicle-type-move`"
                data-testid="vehicle-type-move"
                v-model="set.selectedVehicleType"
                :options="vehicleTypeOptions"
                label="vehicle_type"
                track-by="vehicle_type_id"
                placeholder="Pilih Jenis Kendaraan"
                :class="{ 'is-invalid': $v.set.selectedVehicleType.$error }"
              />
              <div v-if="$v.set.selectedVehicleType.$error" class="invalid-feedback mt-0">
                <span v-if="!$v.set.selectedVehicleType.required">
                  {{ $t('setting.modal.vehicleType') }} Wajib Terisi
                </span>
              </div>
            </div>

            <FormulateInput
              :id="`${componentId}-odometer-move`"
              data-testid="odometer-move"
              type="number"
              name="odometer"
              label="Odometer"
              placeholder="Masukkan Odometer (Km)"
              validation-behavior="live"
              error-behavior="live"
              :validation="['required']"
              :validation-messages="{ required: 'Odometer Wajib Terisi' }"
              mt="2"
              @keydown="portKeydown($event)"
            />

            <FormulateInput
              :id="`${componentId}-vehicle-year-move`"
              data-testid="vehicle-year-move"
              type="number"
              name="vehicleYear"
              label="Tahun Kendaraan"
              placeholder="Masukkan Tahun Kendaraan"
              mt="2"
              @keydown="portKeydown($event)"
            />

            <FormulateInput
              :id="`${componentId}-hull-no-move`"
              data-testid="hull-no-move"
              type="text"
              name="hullNo"
              label="Nomor Lambung"
              placeholder="Masukkan Nomor Lambung"
              mt="2"
            />
          </div>
        </div>

        <!-- ========== WORK ORDER & NOTES (SEKARANG DI DALAM FORM) ========== -->
        <div class="mt-1 mb-3">
          <label :class="isProcessMetadataRequired && 'required'" :for="`${componentId}-work-order`">Nomor Work Order atau Ticket untuk sumber data</label>
          <b-form-input :id="`${componentId}-work-order`" data-testid="work-order" v-model="set.workOrderNumber"
            type="text" placeholder="input nomor WO, tiket jira, atau link freshdesk"
            :class="{ 'is-invalid': $v.set.workOrderNumber.$error }" />
          <div v-if="$v.set.workOrderNumber.$error" class="invalid-feedback mt-0">
            <span v-if="!$v.set.workOrderNumber.required"> Wo Wajib Terisi </span>
          </div>
        </div>

        <div class="mb-3">
          <label :class="isProcessMetadataRequired && 'required'" :for="`${componentId}-notes`">Catatan / Alasan Proses</label>
          <b-form-textarea :id="`${componentId}-notes`" data-testid="notes" v-model="set.notes"
            placeholder="Jelaskan alasan melakukan proses ini..." rows="3"
            :class="{ 'is-invalid': $v.set.notes.$error }" />
          <div v-if="$v.set.notes.$error" class="invalid-feedback mt-0">
            <span v-if="!$v.set.notes.required"> Alasan Wajib Terisi </span>
            <span v-else-if="!$v.set.notes.minLength">
              Reason must have at least 10 characters
            </span>
          </div>
        </div>
      </FormulateForm>

      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col sm="12" md="4" class="mc-modal__filter-footer-fav"></b-col>
          <b-col sm="12" md="8" class="mc-modal__filter-footer-btn">
            <b-button
              :id="`${componentId}-btn-cancel`"
              data-testid="btn-cancel"
              variant="outline-primary"
              @click="cancel"
              class="me-3"
            >
              Batal
            </b-button>
            <b-button
              :id="`${componentId}-btn-save`"
              data-testid="btn-save"
              variant="primary"
              @click="saveProcess"
              :disabled="isLoading"
            >
              <b-spinner v-if="isLoading" small type="grow"></b-spinner>
              Simpan
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <sync-vehicle-log v-if="syncVehicleLogModal" :modal.sync="syncVehicleLogModal" />
    <export-vehicle-log v-if="exportVehicleLogModal" :modal.sync="exportVehicleLogModal" />
    <sync-iccid-log v-if="syncIccidLogModal" :modal.sync="syncIccidLogModal" />
    <sync-move-vehicle-company-log
      v-if="syncMoveVehicleCompanyLogModal"
      :modal.sync="syncMoveVehicleCompanyLogModal"
    />
  </Layout>
</template>

<style>
.formulate-input ul.formulate-input-errors {
  font-style: normal;
  font-size: 80%;
}

/* =========================
   READONLY CHECKBOX
========================= */
.readonly-checkbox label {
  cursor: default !important;
}

.readonly-checkbox input[type='checkbox'] {
  pointer-events: none;
}

/* =========================
   RADIO GROUP
========================= */
.radio-group-inline {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.custom-radio {
  flex-basis: 200px;
  display: flex;
  align-items: center;
}

.custom-radio label {
  white-space: nowrap;
}

/* =========================
   FILTER CARD
========================= */
.filter-card {
  border: 1px solid #dee2e6;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  margin-bottom: 1.5rem;
  overflow: visible;
  background: #fff;
}

.filter-card .card-body {
  padding: 1rem;
}

.filter-card .border-bottom {
  border-bottom: 1px solid #ececec !important;
}

/* =========================
   TOP FILTER AREA
========================= */
.filter-top-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.filter-region-select {
  width: 180px;
  min-width: 150px;
}

.filter-company-select {
  width: 360px;
  min-width: 200px;
  z-index: 99;
}

/* =========================
   SEARCH BOX
========================= */
.filter-search-box {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.65rem 1rem;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 12px;
  min-width: 300px;
  transition: all 0.2s ease;
}

.filter-search-box:hover {
  border-color: #adb5bd;
}

.filter-search-box:focus-within {
  border-color: #0d6efd;
  background-color: #fff;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.12);
}

.filter-search-box i {
  color: #6c757d;
  font-size: 0.9rem;
  flex-shrink: 0;
}

.filter-search-input {
  border: none !important;
  outline: none !important;
  padding: 0 !important;
  background: transparent !important;
  font-size: 0.9rem;
  flex-grow: 1;
}

.filter-search-input::placeholder {
  color: #adb5bd;
}

.filter-search-input:focus {
  box-shadow: none !important;
}

/* =========================
   BUTTON AREA
========================= */
.filter-button-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.filter-label {
  font-size: 12px;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.filter-divider {
  width: 1px;
  height: 28px;
  background: #dee2e6;
}

/* =========================
   BUTTON STYLE
========================= */
.filter-button-group .mc-button,
.filter-button-group button {
  transition: all 0.2s ease;
}

.filter-button-group .mc-button:hover,
.filter-button-group button:hover {
  transform: translateY(-1px);
}

/* =========================
   MODE CARD
========================= */
.mode-card {
  flex: 1;
  cursor: pointer;
  width: 260px;
  transition: all 0.2s;
  display: flex;
}

.mode-card .border {
  background: #fff;
  box-sizing: border-box;
  border: 2px solid transparent;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mode-card .text-muted {
  margin-top: auto;
}

.mode-card.active .border {
  border-color: #2f6fed;
  background: #f4f8ff;
}

.mode-icon {
  font-size: 28px;
}

.mode-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.mode-card.active strong {
  color: #007bff;
}

.mode-card input[type='radio'] {
  pointer-events: none;
}

/* =========================
   TABLET
========================= */
@media (max-width: 992px) {
  .filter-top-wrapper {
    flex-wrap: wrap;
  }

  .filter-search-box {
    width: 100%;
    min-width: unset;
  }

  .filter-company-select {
    flex: 1;
  }
}

/* =========================
   MOBILE
========================= */
@media (max-width: 768px) {
  .filter-card .card-body {
    padding: 0.85rem;
  }

  .filter-top-wrapper {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-region-select,
  .filter-company-select,
  .filter-search-box {
    width: 100% !important;
    max-width: 100% !important;
  }

  .filter-button-group {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-button-group .mc-button,
  .filter-button-group button {
    width: 100%;
    min-height: 48px;
    font-size: 0.95rem;
    border-radius: 12px;
  }

  .filter-button-group i {
    font-size: 1rem;
  }

  .filter-divider {
    display: none;
  }

  .filter-label {
    margin-top: 8px;
    margin-bottom: 2px;
  }

  .ms-auto {
    margin-left: 0 !important;
  }

  .mode-card {
    width: 100%;
    margin-bottom: 10px;
  }
}

/* =========================
   SMALL MOBILE
========================= */
@media (max-width: 576px) {
  .filter-search-box {
    padding: 0.6rem 0.85rem;
  }

  .filter-search-input {
    font-size: 0.85rem;
  }

  .filter-card {
    border-radius: 10px;
  }
}
</style>
